import { render, staticRenderFns } from "./KinvaDocUpdate.vue?vue&type=template&id=6a9cabc4&scoped=true"
import script from "./KinvaDocUpdate.vue?vue&type=script&lang=js"
export * from "./KinvaDocUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9cabc4",
  null
  
)

export default component.exports